
const LocalStorageService = (function () {
    let services = {}
    services.setItem = function (key, value) {
        localStorage.setItem(key, value)
    }

    services.getItem = function (key) {
        return localStorage.getItem(key);
    }
    services.setObject = function (key, value) {
        localStorage.setItem(key, JSON.stringify(value))
    }


    services.getObject = function (key) {
        let value = localStorage.getItem(key);
        return value ? JSON.parse(value) : value
    }

    services.removeItem = function (key) {
        localStorage.removeItem(key)
    }

    services.clear = function () {
        localStorage.clear();
    }
    return services;

}());

export default LocalStorageService;